import React from "react";
import MyButton from "./MyButton";
import profpic from "../assets/profilepic.jpg";
import { Button } from "react-bootstrap";

const AboutMe = () => {
  return (
    <div className="section" id="about-me">
      <div
        id="about-me"
        className="container row justify-content-evenly align-items-center"
      >
        <div className="col-sm-6 text-center">
          <img className="avatar-me my-4" alt="avatar" src={profpic}></img>
        </div>
        <div className="col-sm-5 pb-4">
          <h1 id="title">
            About <span>me</span>
          </h1>
          <p className="about-text">
            I have a high interest in Information and Technology, especially
            Front-End Engineering. I joined the bootcamp at Alterra Academy for
            3 months, learned Javascript programming ReactJs, & NextJS
            framework, HTML, CSS, and Bootstrap. I have also created team
            projects like E-Commerce and Event Planning Projects. Passionate
            about design, which is why I trying to switch careers as a Front End
            Engineer.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
